var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Transform } from 'class-transformer';
import { IsBoolean, IsOptional, IsUUID } from 'class-validator';
/**
 * Text fields of the multipart `POST /ai-documentation/dictations` (Spec § 9);
 * the audio travels as the `file` part. Multipart fields arrive as strings,
 * hence the transform on `replaceOpen`.
 */
export class CreateDictationDto {
    appointmentId;
    patientId;
    /**
     * Rule 3.2-2: discard the caller's own open dictation of this appointment
     * and patient first. Refused (409) when the open dictation belongs to
     * somebody else.
     */
    replaceOpen;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreateDictationDto.prototype, "appointmentId", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreateDictationDto.prototype, "patientId", void 0);
__decorate([
    IsOptional(),
    Transform(({ value }) => value === true || value === 'true'),
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateDictationDto.prototype, "replaceOpen", void 0);
//# sourceMappingURL=create-dictation.dto.js.map